export const TransactionTypes = Object.freeze({
  ALL: 'all',
  UNIQUE: 'unique',
  RECURRENT: 'recurrent',
  CHARGE: 'charge'
})

export default {
  methods: {
    getTransactionTypes() {
      return [
        { id: TransactionTypes.ALL, name: this.$t('transactions.types.all') },
        {
          id: TransactionTypes.UNIQUE,
          name: this.$t('transactions.types.unique')
        },
        {
          id: TransactionTypes.RECURRENT,
          name: this.$t('transactions.types.subscription')
        },
        {
          id: TransactionTypes.CHARGE,
          name: this.$t('transactions.types.charge')
        }
      ]
    },
    getTransactionStates() {
      return [
        { id: 1, name: this.$t('transactions.status.canceled') },
        { id: 2, name: this.$t('transactions.status.succeeded') },
        { id: 3, name: this.$t('transactions.status.active') },
        { id: 4, name: this.$t('transactions.status.pending') },
        { id: 5, name: this.$t('transactions.status.failed') },
        { id: 6, name: this.$t('transactions.status.trialing') },
        { id: 7, name: this.$t('transactions.status.paid') },
        { id: 8, name: this.$t('transactions.status.authorized') },
        { id: 9, name: this.$t('transactions.status.chargedback') },
        { id: 10, name: this.$t('transactions.status.pending_refund') },
        { id: 11, name: this.$t('transactions.status.pending_review') },
        { id: 12, name: this.$t('transactions.status.processing') },
        { id: 13, name: this.$t('transactions.status.refunded') },
        { id: 14, name: this.$t('transactions.status.refused') },
        { id: 15, name: this.$t('transactions.status.waiting_payment') },
        { id: 16, name: this.$t('transactions.status.incomplete') },
        {
          id: 17,
          name: this.$t('transactions.status.requires_payment_method')
        },
        { id: 18, name: this.$t('transactions.status.prenotification_ok') },
        { id: 19, name: this.$t('transactions.status.creating') },
        { id: 20, name: this.$t('transactions.status.lapsed') }
      ]
    },
    getStateByNumber(state) {
      if (state === 1) {
        return this.$t('subscriptions.status.canceled')
      }
      if (state === 2 || state === 7) {
        return this.$t('transactions.status.succeeded')
      }
      if (state === 3) {
        return this.$t('subscriptions.status.active')
      }
      if (state === 6) {
        return this.$t('subscriptions.status.trialing')
      }
      if ([4, 17].includes(state)) {
        return this.$t('transactions.status.pending')
      }
      if (state === 13) {
        return this.$t('transactions.status.refunded')
      }
      if (state === 14) {
        return this.$t('transactions.status.refused')
      }
      if (state === 16) {
        return this.$t('subscriptions.status.incomplete')
      }
      if (state === 18) {
        return this.$t('subscriptions.status.pre_notified')
      }
      return this.$t('transactions.dashboard.failed')
    },
    getStateForColor(state) {
      if ([13, 4, 17].includes(state)) {
        return 'rgba(0, 0, 0, 0.8)'
      }
      return ''
    },
    getStateForFontWeight(state) {
      if ([13, 4, 17].includes(state)) {
        return '900'
      }
      return ''
    },
    getStateForTextColor(state) {
      if ([2, 7, 3, 6, 18].includes(state)) {
        return 'green--text text--accent-4 font-weight-black'
      }
      if ([13, 4, 17].includes(state)) {
        return ''
      }
      return 'red--text text--accent-4 font-weight-black'
    },
    getStateColor(state) {
      if ([2, 7, 3, 6, 18].includes(state)) {
        return 'green--text text--accent-4'
      }
      if ([13, 4, 17].includes(state)) {
        return ''
      }
      return 'red--text text--accent-4'
    },
    getStateByName(state) {
      switch (state) {
        case 'active':
          return this.$t('subscriptions.status.active')
        case 'success':
          return this.$t('subscriptions.status.success')
        case 'pending':
          return this.$t('subscriptions.status.pending')
        case 'trialing':
          return this.$t('subscriptions.status.trialing')
        case 'incomplete':
          return this.$t('subscriptions.status.incomplete')
        case 'success':
          return this.$t('transactions.status.succeeded')
        case 'failed':
          return this.$t('transactions.dashboard.failed')
        case 'cancel':
          return this.$t('subscriptions.status.canceled')
        case 'refused':
          return this.$t('subscriptions.status.refused')
        case 'refunded':
          return this.$t('subscriptions.status.refunded')
        default:
          return state
      }
    },
    getStateValueByName(state) {
      switch (state) {
        case 'cancel':
          return 1
        case 'success':
          return 2
        case 'active':
          return 3
        case 'pending':
          return 4
        case 'failed':
          return 5
        case 'trialing':
          return 6
        case 'refunded':
          return 13
        case 'refused':
          return 14
        case 'incomplete':
          return 16

        default:
          return null
      }
    },
    getNotificationByState(state) {
      switch (state) {
        case 'PENDING_FOR_ACTION':
          return this.$t('subscriptions.status.pending_for_action')
        case 'TREATED':
          return this.$t('subscriptions.status.treated')
        default:
          return state
      }
    }
  }
}
